import { render } from "./DocumentPicker.vue?vue&type=template&id=ae094d8a"
import script from "./DocumentPicker.vue?vue&type=script&lang=js"
export * from "./DocumentPicker.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroWeb\\marriage_beauro_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__